import { shihuoStoreColor, shihuoStoreIcon } from "src/constants/shihuoStores";

import css from "./StoreBadge.module.scss";

interface StoreBadgeProps {
  store: string;
  size?: number;
}

export const StoreBadge = ({ store, size = 18 }: StoreBadgeProps) => {
  const Icon = shihuoStoreIcon(store);

  if (Icon) {
    return <Icon className={css.icon} width={size} height={size} aria-hidden />;
  }

  return (
    <span
      className={css.badge}
      style={{
        backgroundColor: shihuoStoreColor(store),
        width: size,
        height: size,
        fontSize: Math.round(size * 0.6),
      }}
      aria-hidden
    >
      {[...store][0] ?? "?"}
    </span>
  );
};
